export class OnAddEditGroupClass {
    constructor(id: string = null) {
        this.id = id;
    }

    public id: string;
}
